import { getMediaCapabilities } from './client';

// Focus and timer events can arrive during one slow request. Keep one request
// in flight per subscriber instead of stacking requests and stale responses.
export function pollMediaCapabilities(signal, onResult) {
  let pending = false;
  return async () => {
    if (signal.aborted || pending) return;
    pending = true;
    try {
      const caps = await getMediaCapabilities(signal);
      if (!signal.aborted) onResult?.(caps);
    } finally { pending = false; }
  };
}
